import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, enableProfiling, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { ApiModule, BASE_PATH, Configuration } from '@apis/cas/generated';
import { Leerkr8ApiService } from '@core/saves/leerkr8/leerkr8-api.service';
import { LEERKR8_API_SERVICE } from '@core/saves/leerkr8/leerkr8-api.service.interface';
import { Leerkr8SaverService } from '@core/saves/leerkr8/leerkr8-saver.service';
import { MockLeerkr8ApiService } from '@core/saves/leerkr8/mock-leerkr8-api.service';
import { MemorySaverService } from '@core/saves/memory-saver.service';
import { NoopSaverService } from '@core/saves/noop-saver.service';
import { OfflineSaverService } from '@core/saves/offline-saver.service';
import { SAVE_SERVICE, SaveServiceProvider } from '@core/saves/saves.interface';
import { ActivationService } from '@features/auth/activation.service';
import { ACTIVATION_SERVICE } from '@features/auth/activation.service.interface';
import { MockActivationService } from '@features/auth/mock-activation.service';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { CAS_DATA_SERVICE } from './core/lp/cas-data.interface';
import { CasDataService } from './core/lp/cas-data.service';
import { CasOfflineDataService } from './core/lp/cas-offline-data.service';
import { TokenInterceptor } from './core/token.interceptor';

if (environment.production) {
  enableProdMode();
}

if (!environment.production) {
  enableProfiling();
}

export const appConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(ApiModule),
    {
      provide: BASE_PATH,
      useFactory: () => {
        return environment.casHost;
      },
    },
    {
      provide: Configuration,
      useFactory: () =>
        new Configuration({
          basePath: environment.casHost,
        }),
    },
    {
      provide: SAVE_SERVICE,
      useFactory: () => {
        switch (environment.saveService.provider) {
          case SaveServiceProvider.LEERKR8:
            return new Leerkr8SaverService();
          case SaveServiceProvider.LOCAL_STORAGE:
            return new OfflineSaverService();
          case SaveServiceProvider.DONT_SAVE:
            return new NoopSaverService();
          case SaveServiceProvider.MEMORY:
            return new MemorySaverService();
        }
      },
    },
    {
      provide: ACTIVATION_SERVICE,
      useClass: environment.saveService.provider === 'LEERKR8' ? ActivationService : MockActivationService,
    },
    {
      provide: LEERKR8_API_SERVICE,
      useClass: environment.saveService.provider === 'LEERKR8' ? Leerkr8ApiService : MockLeerkr8ApiService,
    },
    {
      provide: CAS_DATA_SERVICE,
      useClass: environment.useOfflineData ? CasOfflineDataService : CasDataService,
    },
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
  ],
};
